import React from 'react';
import SvgIcon from '@mui/material/SvgIcon';
import { useTheme } from '@mui/material';
import getSVGIconToggleColor from '../../../../utils/svg-icons';
import { CustomSvgIconProps, ToggleColorType } from '../../../../types/domain/svg-icons';

export default function QuestionMarkIcon(props: CustomSvgIconProps): JSX.Element {
  const defaultColor = useTheme().palette.primary.dark;
  const color = props.htmlColor || defaultColor;
  return (
    <SvgIcon
      {...props}
      htmlColor={color}
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      titleAccess="question mark">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 12C0 5.373 5.373 0 12 0s12 5.373 12 12-5.373 12-12 12S0 18.627 0 12z"
        fill={getSVGIconToggleColor(ToggleColorType.background, props.toggle!!)}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 19.65a7.65 7.65 0 100-15.3 7.65 7.65 0 000 15.3zM12 21a9 9 0 100-18 9 9 0 000 18z"
        fill={getSVGIconToggleColor(ToggleColorType.highlighted, props.toggle!!)}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 7.275c-.83 0-1.543.498-1.857 1.215a.675.675 0 01-1.236-.541 3.376 3.376 0 113.768 4.658V13.8a.675.675 0 11-1.35 0V12c0-.373.302-.675.675-.675a2.025 2.025 0 100-4.05z"
        fill={getSVGIconToggleColor(ToggleColorType.highlighted, props.toggle!!)}
      />
      <path d="M12.9 16.5a.9.9 0 11-1.8 0 .9.9 0 011.8 0z" fill="#fff" />
    </SvgIcon>
  );
}
